const currencySeparator = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
export const currencyFixer = (number) => number.toString().replace(/,/g, "");
export default currencySeparator;
